import { Outlet } from 'react-router-dom';
import SystemToaster from './components/SystemToast';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <>
      <SystemToaster />

      {/* A rede de proteção: sem isto, um componente que quebra ao renderizar
          deixa a página BRANCA — sem mensagem, sem botão, sem caminho de volta.
          O app não tinha nenhum `ErrorBoundary` até 2026-09-12. */}
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </>
  );
}

export default App;
